import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export type PropertyCheckOutTaskType = 'LOCK_UP' | 'ADDITIONAL_REQUESTS';

export default class PropertyCheckOutTaskModel extends Model {
  @attr('string') type!: PropertyCheckOutTaskType;
  @attr('boolean') enabled!: boolean;
  @attr('string') description!: string;

  @belongsTo('property', {
    inverse: 'propertyCheckOutTasks',
    async: false,
  })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'property-check-out-task': PropertyCheckOutTaskModel;
  }
}
